























































































































































































import Vue from "vue"
import { Country } from "@/model/entity/country/country"
import { countryList, countryService, ICountryService } from "@/model/service/country/country-service"
import Datatable, { DatatableOptions } from "@/components/datatable/Datatable.vue"
import { Address } from "@/model/entity/address/address"
import { addressService, IAddressService } from "@/model/service/address/address-service"
import { FieldDescription } from "@/model/entity/field-descriptor"
import { ColReqAddress } from "@/model/entity/collection-request/col-req-address"
import { DpdCity } from "@/model/dto/dpd-city"
import { includes } from "lodash"

interface IColReqAddressData {
  addressService: IAddressService
  countryService: ICountryService
  options: DatatableOptions
  listAddressesDialog: boolean
  listAddresses: Address[]
  fields: FieldDescription[]
  countryList: Country[]
  rules: any,
  isZipMandatory: boolean,
  postcodepatterns: string
}

export default Vue.extend({
  components: {
    Datatable
  },
  data(): IColReqAddressData {
    return {
      addressService: addressService,
      countryService: countryService,
      options: {
        dialog: true
      },
      listAddressesDialog: false,
      listAddresses: [],
      fields: Address.getFieldDescriptionList(),
      countryList: countryList,
      isZipMandatory: true,
      postcodepatterns: "",
      rules: {
        name: [
          {
            max: 35,
            message: `${this.$t("user_administration.max")} 35 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        name2: [
          {
            max: 35,
            message: `${this.$t("user_administration.max")} 35 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          }
        ],
        country: [
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        city: [
          {
            max: 35,
            message: `${this.$t("user_administration.max")} 35 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        postalCode: [
          {
            max: 8,
            message: `${this.$t("user_administration.max")} 8 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: any, callback: any) => {
              const vm = this as any
              const isZipMandatory = !vm.postcodepatterns.includes(this.$t("popover.zipcode.empty"))
              if (isZipMandatory) {
                if (value === undefined || value === "") {
                  callback(new Error(`${this.$t("user_administration.field_is_required")}`))
                }
              }
              callback()
            },
            trigger: ["change", "blur"]
          }
        ],
        street: [
          {
            max: 35,
            message: `${this.$t("user_administration.max")} 35 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        houseNumber: [
          {
            max: 8,
            message: `${this.$t("user_administration.max")} 8 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
          validator: (rule: any, value: string, callback: (err?: Error) => void) => {
              const vm = this as any
              if (!vm.pickupHouseNumberIsSelected()) {
                callback(new Error
                (`${this.$t("user_administration.field_is_required")}`))
              }
              callback()
          }
            }
        ],
        phone: [
          {
            max: 30,
            message: `${this.$t("user_administration.max")} 30 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: string, callback: (err?: Error) => void) => {
              if (value && !new RegExp(/^[(]?[+]?[0-9 \-\/()]+$/).test(value)) {
                callback(new Error(`${this.$t("user_administration.invalid_format.phone")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          },
           {
            validator: (rule: any, value: string, callback: (err?: Error) => void) => {

              const vm = this as any
              if (!vm.phoneOrEmailSelected()) {
                callback(new Error
                (`${this.$t("collection_request.validation.pickup_address.phone_or_email_mandatory")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          }

        ],
        email: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: string, callback: (err?: Error) => void) => {
              const regexpPattern = /^[\w!#$%&’*+/=?`{|}~^-]+(?:\.[\w!#$%&’*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/
              if (value && !new RegExp(regexpPattern).test(value)) {
                callback(new Error(`${this.$t("user_administration.invalid_format.email")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          },
           {
            validator: (rule: any, value: string, callback: (err?: Error) => void) => {
              const vm = this as any
              if (!vm.phoneOrEmailSelected()) {
                callback(new Error
                (`${this.$t("collection_request.validation.pickup_address.phone_or_email_mandatory")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          }

        ]
      }
    }
  },
  props: {
    colReqAddress: {
      required: true,
      type: Object as () => ColReqAddress
    },
    i18Prefix: {
        required: true,
        type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    addressFormValid: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    fuzzySearchName(input: string, callback: any) {
      if (exists(input) && input.length >= 3) {
        this.addressService.fuzzySearch(input).then(response => {
          callback(response.data)
        })
      } else {
        callback([])
      }
    },
    phoneOrEmailSelected() {
        return this.colReqAddress.phone || this.colReqAddress.email
    },
    pickupHouseNumberIsSelected() {
        let isPickupHouseNumber = true
        const vm = this as any
        if (vm.i18Prefix === "new_collection_request.pickup.") {
            isPickupHouseNumber = !!this.colReqAddress.houseNumber
        }
        return isPickupHouseNumber
    },
    isPickupHouseNumber(prefix: string) {
        return prefix === "new_collection_request.pickup."
    },
    fuzzySearchZipcode(input: string, callback: any) {
      if (exists(input) && input.length >= 3) {
        this.$http
          .get("cities/fuzzy/zipcodes?country_code=" + this.colReqAddress.country!.isoCodeAlpha2 + "&zipcode=" + input)
          .then(response => {
            callback(response.data)
          })
      } else {
        callback([])
      }
    },
    fuzzySearchCity(input: string, callback: any) {
      if (exists(input) && input.length >= 3) {
        this.$http
          .get("cities/fuzzy/cities?country_code=" + this.colReqAddress.country!.isoCodeAlpha2 + "&city=" + input)
          .then(response => {
            callback(response.data)
          })
      } else {
        callback([])
      }
    },
    nameKeyupHandler(event: KeyboardEvent) {
      if (event.ctrlKey && event.shiftKey && (event.key === "S" || event.key === "s")) {
        event.stopPropagation()
        this.openDialog()
      }
    },
    showHint() {
      this.$notify.info({
        title: "Tip",
        message: this.$t("new_parcel.hint.parcel_shop.search_tip").toString(),
        duration: 4000
      })
    },
    setCityAndZipcode(entity: DpdCity) {
      this.colReqAddress.city = entity.name
      this.colReqAddress.postalCode = entity.postalCode
    },
    setAddress(entity: Address) {
      if (entity !== null) {
        this.colReqAddress.name = entity.name
        this.colReqAddress.country = entity.country
        // Contact must be mapped to name2, because name2 is a requirement when sending request to backend
        this.colReqAddress.name2 = entity.contact
        this.colReqAddress.postalCode = entity.zipcode
        this.colReqAddress.city = entity.city
        this.colReqAddress.street = entity.street
        this.colReqAddress.houseNumber = entity.houseNumber
        this.colReqAddress.phone = entity.phone
        this.colReqAddress.email = entity.email
        this.listAddressesDialog = false
      }
    },
    openDialog() {
      this.listAddressesDialog = true
    },
    changeCountry(country: any) {
      this.$emit("update:country", country)
      this.$forceUpdate()
    },
    emitValidation() {
      const vm = this as any
      vm.$refs.form.validate((valid) => {
        this.$emit("update:addressFormValid", valid)
      })

    },
    async getPostcodepatterns(countryCode: string) {
      return Vue.$http.get("/country/postcodepatterns/" + countryCode)
    },
    async setPostcodepatternsPopoverAndValidateForm() {
      if (this.colReqAddress.country !== undefined) {
        const response = await this.getPostcodepatterns(this.colReqAddress.country.isoCodeNumeric)
        const postcodepatterns = response.data.postcodepatterns

        if (postcodepatterns.includes("")) {
          postcodepatterns[postcodepatterns.indexOf("")] = this.$t("popover.zipcode.empty")
        }
        this.postcodepatterns = postcodepatterns.join("\n")
        this.isZipMandatory = !(postcodepatterns.length === 1 && postcodepatterns.includes(this.$t("popover.zipcode.empty")))
        if (!this.isZipMandatory) {
          this.colReqAddress.postalCode = ""
        }
        this.emitValidation()
      }
    }
  },
  computed: {
    filteredCountryList(): Country[] {
      return this.countryList.filter(country => includes(this.$store.getters.colReqCountries, country.isoCodeAlpha2))
    }
  },
  watch: {
    colReqAddress: {
      deep: true,
      handler() {
        this.emitValidation()
      }
    },
    "colReqAddress.country": {
      handler() {
        this.setPostcodepatternsPopoverAndValidateForm()
      }
    },
    "$i18n.locale": {
      handler() {
        this.setPostcodepatternsPopoverAndValidateForm()
      }
    }
  },
  mounted() {
    this.emitValidation()
  },
  async created() {
    this.setPostcodepatternsPopoverAndValidateForm()
  }
})
